import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], term, key: string): any {
    //TODO: ho messo includes perchè nella query-form, l'api manda il type = 'geometry' e lato client è stato gestito come 'geom'. Dovrebbe essere "items.filter(item => item[key].indexOf(term) !== -1 )"
    return term
      ? items.filter(item => item[key].includes(term))
      : items;
  }
}
